module.exports = __webpack_public_path__ + "img/Partners7.878d0c70.png";